// Components
import '@/scripts/components/product-form';

const selectors = {
    builder: '[data-control-kit-builder]',
    select: '[data-control-kit-builder-select]',
    option: '.single-option-selector',
    step: '[data-control-kit-builder-step]',
    image: '[data-control-kit-builder-step-image]',
    nextButton: '[data-control-kit-builder-next]'
};

const classes = {
    hide: 'hide',
};

const attributes = {
    step: 'data-step',
    nextStep: 'data-next-step',
    option: 'data-option',
    optionSelector: 'data-option-selector'
};

function updateImages(controlKitBuilderSelect, currentStep) {
    const images = currentStep?.querySelectorAll(selectors?.image);
    if (!images) {
        return;
    }

    if (!images?.length) {
        return;
    }

    images?.forEach((image) => {
        const value = controlKitBuilderSelect?.value;

        if (
            image?.getAttribute('data-control-kit-builder-step-image') === value
        ) {
            image?.classList?.remove(classes?.hide);
        } else {
            image?.classList?.add(classes?.hide);
        }
    });
}

function controlKitBuilderInit() {
    const builder = document.querySelector(selectors?.builder);
    if (!builder) {
        return;
    }

    const selects = builder?.querySelectorAll(selectors?.select);
    const optionSelectors = builder?.querySelectorAll(selectors?.option);
    const nextStepButtons = builder?.querySelectorAll(selectors?.nextButton);
    const steps = builder?.querySelectorAll(selectors?.step);

    nextStepButtons?.forEach((button) => {
        button?.addEventListener('click', () => {
            const nextStep = button?.getAttribute(attributes?.nextStep);

            if (!steps) {
                return;
            }

            if (!steps?.length) {
                return;
            }

            steps?.forEach((step) => {
                const stepNumber = step?.getAttribute(attributes?.step);
                if (stepNumber !== nextStep) {
                    return;
                }

                window.scrollTo(0, step?.offsetTop);
            });
        });
    });

    selects?.forEach((select) => {
        const currentStep = select.closest(selectors?.step);

        updateImages(select, currentStep);

        select?.addEventListener('change', () => {
            const currentOptionSelector = select?.getAttribute(attributes?.optionSelector);

            updateImages(select, currentStep);

            optionSelectors?.forEach((optionSelector) => {
                if (
                    optionSelector?.getAttribute(attributes?.option) !==
                    currentOptionSelector
                ) {
                    return;
                }

                optionSelector.value = select?.value;

                optionSelector?.dispatchEvent(new Event('change'));
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    controlKitBuilderInit();
});
